<template>
    <span>
        <p class="mb-0">
            <small>
                {{ $t('profile.table.details.achieved') }}
            </small>
        </p>
        <p class="text-right m-0">
            {{ achievedValueByCompany !== null ? `${formatPercentage(achievedValueByCompany)}%` : '-' }}
        </p>
        <ProgressBar :value="achievedValueByCompany" :color="progressBarColor" />
    </span>
</template>

<script>
import ProgressBar from '@/views/components/progress-bar/ProgressBar'
import { formatPercentage } from '@/lib/utils'
import { isCompany } from '@/services/companies-custom-functions'

export default {
    name: 'Achieved',
    props: ['achieved', 'progressBarColor', 'multiplierAchieved'],
    components: {
        ProgressBar,
    },
    data() {
        return {
            isGol: isCompany('gol') || isCompany('testegol'),
        }
    },
    methods: {
        formatPercentage(number) {
            if (isNaN(number)) {
                return 0
            }
            return formatPercentage(number)
        },
    },
    computed: {
        achievedValueByCompany() {
            return this.isGol ? this.multiplierAchieved : this.achieved
        },
    },
}
</script>
